import type { MouseEventHandler } from "react";

import applyClassNames from "classnames";

import type { IconName, IconSize } from "@similarweb/icons";
import type { ButtonType } from "@similarweb/ui-components";

import { StyledListIconButton } from "./styles";

export type ListIconButtonProps = {
    type?: ButtonType;
    iconSize?: IconSize;
    iconName?: IconName;
    isDisabled: boolean;
    buttonText?: string | number;
    dataAutomation?: string;
    onClick: () => void;
    onMouseEnter?: MouseEventHandler<HTMLDivElement>;
};

const ListIconButton = (props: ListIconButtonProps) => {
    const {
        type = "flat",
        dataAutomation,
        isDisabled,
        buttonText,
        iconSize = "xs",
        iconName = "add-to-list",
        onClick,
        onMouseEnter,
    } = props;

    return (
        <div onMouseEnter={onMouseEnter}>
            <StyledListIconButton
                dataAutomation={dataAutomation}
                type={type}
                iconName={iconName}
                onClick={onClick}
                isDisabled={isDisabled}
                iconSize={iconSize}
                className={applyClassNames({ disabled: isDisabled }, type)}
            >
                {buttonText}
            </StyledListIconButton>
        </div>
    );
};

export default ListIconButton;
